import { type EntityState } from '@ngrx/entity';

import { type ChatMessage } from './chat.models';
import { newestPersistedMessage } from './template-configuration-setup-lifecycle';

export interface PendingAnswer {
  readonly $type: 'form' | 'confirmation';
  readonly messageId: string;
  readonly allowsFreeText: boolean;
}

export function pendingAnswer(state: EntityState<ChatMessage>): PendingAnswer | undefined {
  const newest = newestPersistedMessage(state);
  if (newest?.$type !== 'assistant') {
    return undefined;
  }
  const allowsFreeText = newest.allowFreeText === true;
  if (newest.confirmation) {
    return { $type: 'confirmation', messageId: newest.id, allowsFreeText };
  }
  if (newest.form?.questions?.length) {
    return { $type: 'form', messageId: newest.id, allowsFreeText };
  }
  return undefined;
}
